import "./App.css";
import { useEffect, useMemo, useState } from "react";

function App() {
  const [mode, setMode] = useState("neutral"); // neutral | angry | happy
  const [index, setIndex] = useState(0);
  const [noClicks, setNoClicks] = useState(0);

  const currentArray = useMemo(() => {
    const angry = [
      "/angry1.gif",
      "/angry2.gif",
      "/angry3.gif",
      "/angry4.gif",
      "/angry5.gif",
      "/angry6.gif",
      "/angry7.gif",
      "/angry8.gif",
      "/angry9.gif",
      "/angry10.gif",
    ];
    const happy = [
      "/happy1.gif",
      "/happy2.gif",
      "/happy3.gif",
      "/happy4.gif",
      "/happy5.gif",
      "/happy6.gif",
      "/happy7.gif",
      "/happy8.gif",
      "/happy9.gif",
      "/happy10.gif",
    ];
    const neutral = ["/neutral1.gif", "/neutral2.gif", "/neutral3.gif"];
    if (mode === "neutral") return neutral;
    if (mode === "angry") return angry;
    return happy;
  }, [mode]);

  // Auto-loop for neutral and happy every 2 seconds
  useEffect(() => {
    if (mode === "neutral" || mode === "happy") {
      const id = setInterval(() => {
        setIndex((prev) => (prev + 1) % (currentArray.length || 1));
      }, 2000);
      return () => clearInterval(id);
    }
  }, [mode, currentArray]);

  // Reset index when switching modes
  useEffect(() => {
    setIndex(0);
  }, [mode]);

  const onNo = () => {
    setMode("angry");
    setIndex((prev) => (prev + 1) % (10));
    setNoClicks((c) => Math.min(10, c + 1));
  };

  const onYes = () => {
    setMode("happy");
  };

  const yesScale = 1 + noClicks * 0.1; // grows up to 2.0 at 10 clicks
  const noScale = Math.max(0.2, 1 - noClicks * 0.08); // shrinks down to 0.2 at 10 clicks
  const baseFont = 16;
  const basePadY = 12;
  const basePadX = 20;
  // Transform-based scaling

  return (
    <div className="screen">
      <div
        className="bg"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/background2.gif)`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          filter: mode === 'happy' ? 'grayscale(0)' : `grayscale(${Math.min(1, noClicks / 10)})`,
        }}
      />
      <div className="top">
        <h2 className="valentine-text" style={{zIndex: 101}}>Will you be my valentine?</h2>
      </div>

      <div className="middle">
        {currentArray.length > 0 ? (
          <img
            src={currentArray[index % currentArray.length]}
            alt={`${mode}-${index}`}
            className="image-fit"
            style={{zIndex: 100}}
          />
        ) : (
          <div>No images provided.</div>
        )}
      </div>

      <div className="bottom">
        {mode !== "happy" ? (
          <div className="buttons">
            <button
              className="btn btn-yes"
              style={{
                fontSize: `${baseFont}px`,
                padding: `${basePadY}px ${basePadX}px`,
                transform: `scale(${yesScale})`,
              }}
              onClick={onYes}>
              YES
            </button>
            <button
              className="btn btn-no"
              style={{
                fontSize: `${baseFont}px`,
                padding: `${basePadY}px ${basePadX}px`,
                transform: `scale(${noScale})`,
              }}
              onClick={onNo}>
              no
            </button>
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}

export default App;
